/**
 * Cross-tab "the login state changed" signal. Carries no payload that is trusted: a receiving tab
 * re-asks the server (CheckSessionStatus) instead of believing the message.
 */
const CHANNEL_NAME = 'cablepro-auth';
const STORAGE_KEY = 'cablepro-auth-changed';

export class AuthChangeSignal {
    private static channel: BroadcastChannel | null = null;

    static notify(): void {
        try {
            if (typeof BroadcastChannel !== 'undefined') {
                AuthChangeSignal.getChannel()?.postMessage(Date.now());
            } else {
                // 'storage' only fires in other tabs, which is exactly what is wanted.
                localStorage.setItem(STORAGE_KEY, String(Date.now()));
            }
        } catch { /* best effort - the slow safety-net poll still catches it */ }
    }

    /** Returns an unsubscribe function. */
    static listen(handler: () => void): () => void {
        try {
            if (typeof BroadcastChannel !== 'undefined') {
                const channel = new BroadcastChannel(CHANNEL_NAME);
                channel.onmessage = () => handler();
                return () => channel.close();
            }
        } catch { /* fall through to storage */ }

        const onStorage = (e: StorageEvent) => {
            if (e.key === STORAGE_KEY) {
                handler();
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }

    private static getChannel(): BroadcastChannel | null {
        if (!AuthChangeSignal.channel) {
            AuthChangeSignal.channel = new BroadcastChannel(CHANNEL_NAME);
        }
        return AuthChangeSignal.channel;
    }
}
